import { defineRecipe } from '@chakra-ui/react';

/** KDS Status Badge — colored badge for status labels. Register as `statusBadge` in theme/system.ts. */
export const statusBadgeRecipe = defineRecipe({
  base: {
    alignItems: 'center',
    display: 'inline-flex',
    flexShrink: 0,
    textStyle: 'default.regular',
    whiteSpace: 'nowrap',
    borderRadius: 'full',
  },
  variants: {
    variant: {
      default: {
        px: '2',
        py: '1',
      },
      withIcon: {
        py: '1',
        pl: '1',
        pr: '2',
        gap: '1',
      },
    },
    colorPalette: {
      neutral: {
        bg: 'neutral.100',
        color: 'neutral.500',
      },
      green: {
        bg: 'green.100',
        color: 'green.900',
      },
      red: {
        bg: 'red.100',
        color: 'red.900',
      },
      orange: {
        bg: 'orange.100',
        color: 'orange.900',
      },
      blue: {
        bg: 'blue.50',
        color: 'blue.800',
      },
      gradient: {
        // Chakra bgGradient looks up keys inside the gradients category (`primary`),
        // not the full token path (`gradients.primary`).
        bgGradient: 'primary',
        color: 'neutral.500',
      },
      // Transparent fill + neutral border (same geometry as solid badges).
      transparent: {
        bg: 'transparent',
        color: 'neutral.500',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'neutral.200',
      },
    },
    size: {
      sm: {
        textStyle: 'xs',
        px: '1',
        py: '0.5',
      },
      md: {},
    },
  },
  defaultVariants: {
    variant: 'default',
    colorPalette: 'neutral',
    size: 'md',
  },
});
